export const INTERACT_SIZES = {
  pageContainerWidth: 752,
  rightPagePadding: 30,
  leftPagePadding: 30,
  pageMarginBottom: 20,
};
